import React from "react";

import { useLocation, useNavigate, useParams } from "react-router";

import HeaderButton from "@app/analytics/components/reports/HeaderButton";
import type { PersonTalkTimeInfo } from "@app/analytics/types";
import { UsersIcon } from "@app/common/assets/icons";
import ROUTES from "@app/common/routes";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import { MenuTitle } from "@rui/Menu";
import { Column } from "@rui/Stack";

import { ParticipantMenu, ParticipantMenuItem, ParticipantRow } from "./styles";

const MAX_NUM_BEFORE_OVERFLOW = 6; // change the padding of the menu based on scrollbar visibility

const ParticipantsListButtonAndPopover = ({
  data,
  disabled,
  numParticipants,
}: {
  data: PersonTalkTimeInfo[];
  disabled: boolean;
  numParticipants: number;
}) => {
  const { anchorEl, onClose, open, onClick } = useAnchorElement();

  const navigate = useNavigate();
  const { sessionId } = useParams();
  const location = useLocation();

  const id = open ? "participants-popover" : undefined;
  const padding = data.length > MAX_NUM_BEFORE_OVERFLOW ? 1.5 : undefined;

  const handleClick = () => {
    if (!sessionId || location.pathname.includes("deep-dive")) return;
    return navigate(ROUTES.meetingReportTabById(sessionId, "deep-dive"));
  };

  return (
    <>
      <HeaderButton
        className="meeting-report__header__participants"
        startIcon={<UsersIcon />}
        aria-describedby={id}
        onClick={onClick}
        disabled={disabled}
      >
        Participants ({numParticipants})
      </HeaderButton>
      <ParticipantMenu open={open} onClose={onClose} anchorEl={anchorEl}>
        <MenuTitle sx={{ pr: padding }}>
          Meeting Participants ({numParticipants})
        </MenuTitle>
        <Column pr={padding}>
          {data.map((d) => (
            <ParticipantMenuItem
              key={d.name}
              disableRipple
              onClick={handleClick}
            >
              <ParticipantRow participant={d} />
            </ParticipantMenuItem>
          ))}
        </Column>
      </ParticipantMenu>
    </>
  );
};

export default ParticipantsListButtonAndPopover;
